import {
    GET_PLCC_DETAILS_HTML,
    SET_PLCC_SLIDER_OPEN,
} from '../actionTypes/PlccDynamicBannerActionTypes';

export const getPLCCDetailsHtml = (href) => ({
    type: GET_PLCC_DETAILS_HTML,
    href,
});

export const setPLCCSliderOpen = (plccSliderOpen = true) => ({
    type: SET_PLCC_SLIDER_OPEN,
    plccSliderOpen,
});
